import { z } from 'zod';

export const diagnoseToolInputSchema = z.object({
  icd10Code: z.string().trim().min(1, 'ICD-10 code is required'),
  note: z.string().trim().min(1, 'A clinical note is required'),
});

export type DiagnoseToolInput = z.infer<typeof diagnoseToolInputSchema>;

export type DiagnoseFromToolInputResult = { ok: true; draft: DiagnoseToolInput } | { ok: false };

export function diagnoseFromToolInput(input: unknown): DiagnoseFromToolInputResult {
  const parsed = diagnoseToolInputSchema.safeParse(input);
  if (!parsed.success) {
    console.error('[diagnose] Tool call input validation failed', {
      errors: parsed.error.format(),
      input,
    });
    return { ok: false };
  }
  return { ok: true, draft: parsed.data };
}
